import { render, staticRenderFns } from "./ScreenFormComponent.vue?vue&type=template&id=30a6b042&scoped=true&"
import script from "./ScreenFormComponent.vue?vue&type=script&lang=js&"
export * from "./ScreenFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFormComponent.vue?vue&type=style&index=0&id=30a6b042&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a6b042",
  null
  
)

export default component.exports